import { render, staticRenderFns } from "./AlipayRefund.vue?vue&type=template&id=3833c118&scoped=true&"
import script from "./AlipayRefund.vue?vue&type=script&lang=js&"
export * from "./AlipayRefund.vue?vue&type=script&lang=js&"
import style0 from "./AlipayRefund.vue?vue&type=style&index=0&id=3833c118&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833c118",
  null
  
)

export default component.exports